import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
        authority: process.env.REACT_APP_MSAL_AUTHORITY,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: true,
    },    
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },

    system: {
        loggerOptions: {
            loggerCallback: (level, _message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        return;
                    case LogLevel.Warning:
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'user.read'],
  prompt: 'select_account',
};